import { render, staticRenderFns } from "./ClubLink.vue?vue&type=template&id=feda041c&"
import script from "./ClubLink.vue?vue&type=script&lang=js&"
export * from "./ClubLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports